import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
  SubmitPolicyholderDataClientRequest,
  SubmitPolicyholderDataClientResponse,
} from '../../../@types/SubmitPolicyholderData'
import { api } from '../../../Services/API'
import { SubmitPolicyHolderDataStore } from '../../../Stores/useSubmitPolicyholderDataStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { useErrorRequest } from '../../useErrorRequest'

const request = async (payload: SubmitPolicyholderDataClientRequest) => {
  const response = await api.post<SubmitPolicyholderDataClientResponse>(
    API_ROUTES.submitPolicyHolderData,
    payload,
  )

  return response.data
}

export const useSubmitPolicyholderData = () => {
  const { handleErrorRequest } = useErrorRequest()
  const { setSubmitPolicyHolderData } = SubmitPolicyHolderDataStore()

  return useMutation({
    mutationFn: (payload: SubmitPolicyholderDataClientRequest) =>
      request(payload!),
    onSuccess(data) {
      setSubmitPolicyHolderData(data)
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
